import { Suspense } from 'react';
import { Navigate, Outlet } from 'react-router';
import { useLogout, useSession } from '../auth/session';
import { SectionRail } from './SectionRail';
import { Spinner } from './ui';

/**
 * The frame every signed-in page sits in: the section rail, then the page.
 *
 * A layout route rather than a component each page renders, so the rail is mounted once and does
 * not remount — and so its active state comes from the router rather than from a prop every page
 * would have to remember to pass.
 */
export function AppShell() {
  const { data: user, isPending } = useSession();
  const logout = useLogout();

  if (isPending) {
    return (
      <div className="flex h-full items-center justify-center">
        <Spinner label="Loading your drawer" />
      </div>
    );
  }

  // Everything is behind login; there is no anonymous browsing.
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="flex h-full">
      <SectionRail displayName={user.displayName} onSignOut={() => logout.mutate()} />
      {/* The rail stays put while a lazy section loads, so the frame does not flash. */}
      <div className="min-w-0 flex-1">
        <Suspense
          fallback={
            <div className="flex h-full items-center justify-center">
              <Spinner />
            </div>
          }
        >
          <Outlet />
        </Suspense>
      </div>
    </div>
  );
}
